// components/TestimonialCarousel.tsx
'use client';

import React from 'react';
import { Carousel } from 'react-bootstrap';
import './testimonialCarousel.scss';

export type TestimonialSlide = {
  Quote: string;
  Name: string | null; // Allow null for Name
  Location?: string | null; // Optional and can be null
  _type?: 'slide'; // Sanity-specific field
  _key?: string; // Sanity-specific field
};

type TestimonialCarouselProps = {
  slides: TestimonialSlide[];
  textColorClass?: string;
};

export const TestimonialCarousel = ({
  slides,
  textColorClass = '',
}: TestimonialCarouselProps) => {
  if (!slides || slides.length === 0) {
    return <div className="no-testimonials">No testimonials available</div>;
  }

  return (
    <div className="testimonial-carousel-container">
      <Carousel
        fade
        controls={false}
        indicators={slides ? slides.length > 1 : false}
      >
        {slides.map((slide, index) => (
          <Carousel.Item key={slide?._key || `testimonial-${index}`}>
            <div className={`quotemarks ${textColorClass}`}>“</div>
            <p className={`text-center ${textColorClass}`}>{slide?.Quote}</p>
            <div className={`quotemarks ${textColorClass}`}>”</div>
            {(slide?.Name || slide?.Location) && (
              <div className={`testimonial-author ${textColorClass}`}>
                {slide?.Location && (
                  <div className="quote">
                    <strong className={textColorClass}>{slide?.Name}</strong>
                    <br />
                    <span className={textColorClass}>{slide?.Location}</span>
                  </div>
                )}
              </div>
            )}
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};
